import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	theme: 'light'
};

export const systemSlice = createSlice({
	name: 'system',
	initialState,
	reducers: {
		toggleTheme: (state, action) => {
			state.theme = state.theme === 'dark' ? 'light' : 'dark';
		}
	}
});

export const { toggleTheme } = systemSlice.actions;

export default systemSlice.reducer;
